export var DEFAULT_REPEAT_INTERVAL = 1000;
export var MAX_REPEAT_INTERVAL = 16000;
export var MAX_REPEAT_COUNT = 10;